/**
 * Day.js helpers; **display** times use US Eastern (handles DST via IANA zone).
 */
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

/** All admin UI timestamps are shown in New York local time. */
export const APP_DISPLAY_TZ = 'America/New_York'

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_TIME_MINUTE_FORMAT = 'YYYY-MM-DD HH:mm'
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FILENAME_FORMAT = 'YYYYMMDD-HHmmss'
/** Short wall clock for compact tables */
export const DATE_MM_DD_HHmm = 'MM-DD HH:mm'

export function formatToDateTime(date?: dayjs.ConfigType, format = DATE_TIME_FORMAT): string {
  if (date === undefined || date === null || (typeof date === 'string' && date.trim() === '')) {
    return dayjs().tz(APP_DISPLAY_TZ).format(format)
  }
  const d = dayjs(date)
  if (!d.isValid()) return ''
  return d.tz(APP_DISPLAY_TZ).format(format)
}

export function formatToDate(date?: dayjs.ConfigType, format = DATE_FORMAT): string {
  if (date === undefined || date === null || (typeof date === 'string' && date.trim() === '')) {
    return dayjs().tz(APP_DISPLAY_TZ).format(format)
  }
  const d = dayjs(date)
  if (!d.isValid()) return ''
  return d.tz(APP_DISPLAY_TZ).format(format)
}

/**
 * Format backend ISO/numeric timestamps for tables; empty → ``—``, invalid → raw string.
 */
export function formatIsoInNy(
  iso: string | null | undefined,
  format: string = DATE_TIME_FORMAT
): string {
  if (iso == null || String(iso).trim() === '') return '—'
  const d = dayjs(iso)
  if (!d.isValid()) return String(iso)
  return d.tz(APP_DISPLAY_TZ).format(format)
}

/** Current instant, formatted in New York (e.g. export filenames). */
export function formatNowInNy(template: string): string {
  return dayjs().tz(APP_DISPLAY_TZ).format(template)
}

export const dateUtil = dayjs
export { dayjs }
